export const refresh = () => window.location.reload();
